import g from '#core/global';
import load from '#core/load';

const group_$ = '.expandable-field-group';
const toggle_field_group_$ = '.toggle-field-group';
const range_group_$ = '.range-group';
const option_$ = '.toggle-field-option';
const button_$ = '.expandable-field-group__expandable-button';
const summary_$ = '.expandable-field-group__summary';
const field_summary_attr = 'data-summary-current';
const field_summary_default_attr = 'data-summary-default';
const multi_field_delimiter = ' • ';

let has_group = false;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('expandable-field-group')) return false;
		
		load.content(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
		load.all(() => {
			has_group = assign_elements();
			if (!has_group) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_group) return true;
	
	// Initialize button summaries on page load
	const $expandable_groups = document.querySelectorAll(group_$);
	$expandable_groups.forEach($group => {
		update_button_summary($group);
	});
	
	// Listen for changes in toggle-field-group options within expandable-field-group
	document.addEventListener(g.change_e, e => {
		const $option = e.target.closest(option_$);
		if (!$option) return;
		
		const $toggle_group = $option.closest(toggle_field_group_$);
		if (!$toggle_group) return;
		
		const $expandable_group = $toggle_group.closest(group_$);
		if (!$expandable_group) return;
		
		// Wait for toggle-field-group to update its data-summary-current, then update button
		setTimeout(() => {
			update_button_summary($expandable_group);
		}, 0);
	});
	
	// Listen for input changes in range-group within expandable-field-group
	document.addEventListener('input', e => {
		// Check if this is a range input
		if (!e.target.matches('.range-group__field')) return;
		
		const $range_group = e.target.closest(range_group_$);
		if (!$range_group) return;
		
		const $expandable_group = $range_group.closest(group_$);
		if (!$expandable_group) return;
		
		// Wait for range-group to update its data-summary-current, then update button
		setTimeout(() => {
			update_button_summary($expandable_group);
		}, 0);
	});
	
	// Listen for input changes in regular text fields within expandable-field-group
	document.addEventListener('input', e => {
		// Check if this is a regular text input field (not range, not search)
		if (!e.target.matches('input[type="text"]')) return;
		
		const $field_wrapper = e.target.closest('.field');
		if (!$field_wrapper) return;
		
		const $expandable_group = $field_wrapper.closest(group_$);
		if (!$expandable_group) return;
		
		// Update the field's data-summary-current attribute
		const value = e.target.value.trim();
		const default_summary = $field_wrapper.getAttribute(field_summary_default_attr);
		
		if (value) {
			// Use the actual value
			$field_wrapper.setAttribute(field_summary_attr, value);
		} else if (default_summary) {
			// Revert to default when empty
			$field_wrapper.setAttribute(field_summary_attr, default_summary);
		} else {
			// Remove if no value and no default
			$field_wrapper.removeAttribute(field_summary_attr);
		}
		
		// Update button summary
		update_button_summary($expandable_group);
	});
	
	return true;
}


/**
 * Update the expandable button summary by reading from all contained fields
 * @param {HTMLElement} $expandable_group - The expandable-field-group container
 */
function update_button_summary($expandable_group) {
	const $button = $expandable_group.querySelector(button_$);
	if (!$button) return false;
	
	// Find all fields with summaries (toggle-field-group, range-group, etc.)
	const $fields_container = $expandable_group.querySelector('.expandable-field-group__fields');
	if (!$fields_container) return false;
	
	// Get all direct child field wrappers
	const $field_wrappers = $fields_container.querySelectorAll('.expandable-field-group__field');
	
	const summaries = [];
	$field_wrappers.forEach($wrapper => {
		// Look for any element with data-summary-current
		const $field = $wrapper.querySelector(`[${field_summary_attr}]`);
		if ($field) {
			const field_summary = $field.getAttribute(field_summary_attr);
			if (field_summary) {
				summaries.push(field_summary);
			}
		}
	});
	
	// Remove all existing summary spans
	const $existing_summaries = $button.querySelectorAll(summary_$);
	$existing_summaries.forEach($summary => $summary.remove());
	
	// Find the button text wrapper (buttons wrap their text in .button__text)
	const $button_text = $button.querySelector('.button__text');
	const $target = $button_text || $button;
	
	// Create a new summary span for each summary value
	// Each field type is responsible for defining its own default summary
	summaries.forEach(summary => {
		const $new_summary = document.createElement('span');
		$new_summary.className = 'expandable-field-group__summary';
		$new_summary.textContent = summary;
		$target.appendChild($new_summary);
	});
}
